module.exports = __webpack_public_path__ + "static/media/back-svg-white.3711de94.svg";